import React from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import SchemaIcon from '@mui/icons-material/Schema';
import NotificationsIcon from '@mui/icons-material/Notifications';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import BarChartIcon from '@mui/icons-material/BarChart';
import BlockIcon from '@mui/icons-material/Block';
import DescriptionIcon from '@mui/icons-material/Description';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ScienceIcon from '@mui/icons-material/Science';

const drawerWidth = 240;

export function DeveloperLayout() {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            marginTop: '64px', // Height of the AppBar
          },
        }}
      >
        <Box sx={{ overflow: 'auto', p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Developer Portal
          </Typography>
          <List>
            <ListItem 
              onClick={() => navigate('/developer/workflows')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <SchemaIcon />
              </ListItemIcon>
              <ListItemText primary="Workflows" />
            </ListItem>
            <ListItem 
              onClick={() => navigate('/developer/notifications')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="Notifications" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/release')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <RocketLaunchIcon />
              </ListItemIcon>
              <ListItemText primary="Release" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/metrics')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <BarChartIcon />
              </ListItemIcon>
              <ListItemText primary="Metrics" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/restrictions')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <BlockIcon />
              </ListItemIcon>
              <ListItemText primary="Restrictions" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/lpoa')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText primary="LPOA" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/gifts')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <CardGiftcardIcon />
              </ListItemIcon>
              <ListItemText primary="Gifts" />
            </ListItem>
            <ListItem
              onClick={() => navigate('/developer/test-groups')}
              sx={{ cursor: 'pointer' }}
            >
              <ListItemIcon>
                <ScienceIcon />
              </ListItemIcon>
              <ListItemText primary="Test Groups" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: '64px' }}>
        <Outlet />
      </Box>
    </Box>
  );
} 